import { loadSessionIfPresent } from "@/helpers/heritage-integration/order-helper";
import { routeData } from "@/router/constants/routes";

export async function loadSessionBeforeEnter(to, from) {
    const loadSessionResponse = await loadSessionIfPresent(false, to.name);

    return {
        name: routeData.AUTO_ROUTE.name,
        replace: true,
    };
}
